import { render, staticRenderFns } from "./producer-password.vue?vue&type=template&id=51af3c9c&scoped=true"
import script from "./producer-password.vue?vue&type=script&lang=js"
export * from "./producer-password.vue?vue&type=script&lang=js"
import style0 from "./producer-password.vue?vue&type=style&index=0&id=51af3c9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51af3c9c",
  null
  
)

export default component.exports